module.exports = __webpack_public_path__ + "static/planet-53f3261ecd80332368c58706c037cafe.png";